import { render, staticRenderFns } from "./ShareExperience4.vue?vue&type=template&id=f81771fc&scoped=true"
import script from "./ShareExperience4.vue?vue&type=script&lang=js"
export * from "./ShareExperience4.vue?vue&type=script&lang=js"
import style0 from "./ShareExperience4.vue?vue&type=style&index=0&id=f81771fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81771fc",
  null
  
)

export default component.exports